import React, { Component } from "react"
import * as dateHelper from "../../booking/helpers/date"
import * as endpoints from "../../api/endpoints"
import TravelGuideStep1 from "./travel-guide-step1"
import { getQueryStringValue, setQueryStringValue, setQueryStringValueWithPushState } from "../../api/queryStringHelper"
import TravelGuideStep2 from "./travel-guide-step2"
import TravelGuideStep3 from "./travel-guide-step3"
import TravelGuideStep4 from "./travel-guide-step4"
import * as keys from "../../constants/keys"
import HeroOverlap from "../hero/hero-overlap"
import { UserProfile } from "../../hooks/userProfile"
import Spinner from "../../booking/components/spinner"
import Emitter from "../../helpers/emitter"
import * as emits from "../../constants/emits"
import * as trackingHelper from "../../helpers/tracking"

class TravelGuide extends Component {
  constructor(props) {
    super(props)
    this.containerRef = React.createRef()
    this.state = {
      activeTab: parseInt(getQueryStringValue("at")) || 1,
      activeStep: parseInt(getQueryStringValue("as")) || 1,
      departureDate: getQueryStringValue("dd") || "",
      arrivalDate: getQueryStringValue("ad") || "",
      departureQuery: getQueryStringValue("dq") || "",
      arrivalQuery: getQueryStringValue("aq") || "",
      query: getQueryStringValue("q") || "",
      time: "00:00",
      arrivingFlights: [],
      departingFlights: [],
      departingFlightId: getQueryStringValue("df") || "",
      arrivingFlightId: getQueryStringValue("af") || "",
      travelForm: getQueryStringValue("tf") || undefined,
      travelsWithChildren:
        getQueryStringValue("twc") === "true"
          ? true
          : getQueryStringValue("twc") === "false"
            ? false
            : getQueryStringValue("twc") === "null"
              ? null
              : undefined,
      travelsWithLuggage:
        getQueryStringValue("twl") === "true"
          ? true
          : getQueryStringValue("twl") === "false"
            ? false
            : getQueryStringValue("twl") === "null"
              ? null
              : undefined,
      heroOverlap: undefined,
      ajaxSpinnerActive: false,
    }
  }
  normalizeDate = (dateString) => dateHelper.formatDate(dateHelper.getDateFromFormat(dateString, "DD / MM / YYYY"), "YYYY-MM-DD", "da")

  componentDidMount() {
    const { config } = this.props
    let { departureDate } = this.state
    if (!departureDate) {
      const date = new Date()
      departureDate = dateHelper.formatDate(date, "YYYY-MM-DD", "da")
      this.setState({ departureDate })
    } else {
      // prefilled from querystring
      this.handleSearchClick()
    }
    if (this.state.activeStep === 1 && this.state.activeTab === 1) {
      this.handleSearchClick()
    }
    if (config && this.state.activeStep) {
      switch (this.state.activeStep) {
        case 1:
          this.setState({ heroOverlap: config?.heroOverlapBlockStep1ViewModel })
          break
        case 2:
          this.setState({ heroOverlap: config?.heroOverlapBlockStep2ViewModel })
          break
        case 3:
          this.setState({ heroOverlap: config?.heroOverlapBlockStep3ViewModel })
          break
        case 4:
          this.setState({ heroOverlap: config?.heroOverlapBlockStep4ViewModel })
          break
      }
    }
    const { departingFlightId, arrivingFlightId } = this.state
    if (departingFlightId) {
      const departingFlights =
        sessionStorage.getItem(keys.SESSION_STORAGE_DEPARTING_FLIGHTS) && JSON.parse(sessionStorage.getItem(keys.SESSION_STORAGE_DEPARTING_FLIGHTS))
      const departingFlight = departingFlights?.find((x) => x.RecordId === departingFlightId)
      this.setState({ departingFlight })
    }
    if (arrivingFlightId) {
      const arrivingFlights =
        sessionStorage.getItem(keys.SESSION_STORAGE_ARRIVING_FLIGHTS) && JSON.parse(sessionStorage.getItem(keys.SESSION_STORAGE_ARRIVING_FLIGHTS))
      const arrivingFlight = arrivingFlights?.find((x) => x.RecordId === arrivingFlightId)
      this.setState({ arrivingFlight })
    }

    window.addEventListener("popstate", () => {
      this.setState({
        departureDate: getQueryStringValue("dd") || "",
        arrivalDate: getQueryStringValue("ad") || "",
        departureQuery: getQueryStringValue("dq") || "",
        arrivalQuery: getQueryStringValue("aq") || "",
        activeTab: parseInt(getQueryStringValue("at")) || 1,
        activeStep: parseInt(getQueryStringValue("as")) || 1,
        query: getQueryStringValue("q") || "",
        departingFlightId: getQueryStringValue("df") || "",
        arrivingFlightId: getQueryStringValue("af") || "",
        travelForm: getQueryStringValue("tf") || null,
        travelsWithChildren:
          getQueryStringValue("twc") === "true"
            ? true
            : getQueryStringValue("twc") === "false"
              ? false
              : getQueryStringValue("twc") === "null"
                ? null
                : undefined,
        travelsWithLuggage:
          getQueryStringValue("twl") === "true"
            ? true
            : getQueryStringValue("twl") === "false"
              ? false
              : getQueryStringValue("twl") === "null"
                ? null
                : undefined,
      })
    })
  }
  componentDidUpdate(prevProps, prevState) {
    const newState = { ...this.state }
    if (prevState.activeTab !== this.state.activeTab) {
      if (this.state.activeTab === 2) {
        let arrivalDate = this.state.arrivalDate
        if (!arrivalDate) {
          arrivalDate = dateHelper.formatDate(dateHelper.AddDays(this.state.departureDate, 7), "YYYY-MM-DD", "da")
        }
        let arrivalQuery = this.state.arrivalQuery
        if (!arrivalQuery || arrivalQuery === "") {
          if (this.state.departingFlight) {
            arrivalQuery = this.state.departingFlight.Destination.split(/[^a-zA-Z0-9 ]/)[0]
          } else {
            arrivalQuery = this.state.query
          }
        }
        newState.arrivalDate = arrivalDate
        newState.arrivalQuery = arrivalQuery
        newState.query = arrivalQuery

        const arrivingFlightId = this.state.arrivingFlightId
        if (arrivingFlightId) {
          const arrivingFlights =
            sessionStorage.getItem(keys.SESSION_STORAGE_ARRIVING_FLIGHTS) && JSON.parse(sessionStorage.getItem(keys.SESSION_STORAGE_ARRIVING_FLIGHTS))
          const arrivingFlight = arrivingFlights?.find((x) => x.RecordId === arrivingFlightId)
          if (arrivingFlight) newState.arrivingFlight = arrivingFlight
        }
        this.setState(newState, () => this.handleSearchClick())
      } else {
        if (this.state.departureDate) newState.date = this.state.departureDate
        let departureQuery = this.state.departureQuery
        if (!departureQuery) {
          departureQuery = this.state.query
        }
        newState.departureQuery = departureQuery
        newState.departureQuery = departureQuery
        newState.query = departureQuery

        this.setState(newState, () => this.handleSearchClick())
      }
    }
    if (prevState.activeStep !== this.state.activeStep) {
      this.scrollToContainer()
    }
    this.applyStateToQueryParams(prevState, newState)
  }

  applyStateToQueryParams(prevState, newState) {
    if (prevState.departureDate !== newState.departureDate) setQueryStringValue("dd", newState.departureDate)
    if (prevState.arrivalDate !== newState.arrivalDate) setQueryStringValue("ad", newState.arrivalDate)
    if (prevState.departureQuery !== newState.departureQuery) setQueryStringValue("dq", newState.departureQuery)
    if (prevState.arrivalQuery !== newState.arrivalQuery) setQueryStringValue("aq", newState.arrivalQuery)
    if (prevState.activeTab !== newState.activeTab) setQueryStringValueWithPushState("at", newState.activeTab)
    if (prevState.activeStep !== newState.activeStep) setQueryStringValueWithPushState("as", newState.activeStep)
    if (prevState.query !== newState.query) setQueryStringValue("q", newState.query)
    if (prevState.arrivingFlightId !== newState.arrivingFlightId) setQueryStringValue("af", newState.arrivingFlightId)
    if (prevState.departingFlightId !== newState.departingFlightId) setQueryStringValue("df", newState.departingFlightId)
    if (prevState.travelForm !== newState.travelForm) setQueryStringValue("tf", newState.travelForm)
    if (prevState.travelsWithChildren !== newState.travelsWithChildren)
      setQueryStringValue("twc", newState.travelsWithChildren === null ? "null" : newState.travelsWithChildren)
    if (prevState.travelsWithLuggage !== newState.travelsWithLuggage)
      setQueryStringValue("twl", newState.travelsWithLuggage === null ? "null" : newState.travelsWithLuggage)
    if (prevState.activeStep !== newState.activeStep) {
      switch (newState.activeStep) {
        case 1:
          this.setState({ heroOverlap: this.props.config?.heroOverlapBlockStep1ViewModel })
          break
        case 2:
          this.setState({ heroOverlap: this.props.config?.heroOverlapBlockStep2ViewModel })
          break
        case 3:
          this.setState({ heroOverlap: this.props.config?.heroOverlapBlockStep3ViewModel })
          break
        case 4:
          this.setState({ heroOverlap: this.props.config?.heroOverlapBlockStep4ViewModel })
          break
      }
    }
  }

  scrollToContainer() {
    this.containerRef.current?.scrollIntoView()
  }

  handleDateChange(date) {
    const normalizedDate = this.normalizeDate(date)
    switch (this.state.activeTab) {
      case 1:
        this.setState({ departureDate: normalizedDate }, () => this.handleSearchClick())
        break
      case 2:
        this.setState({ arrivalDate: normalizedDate }, () => this.handleSearchClick())
    }
  }
  handleTimeChange(time) {
    this.setState({ time }, () => this.handleSearchClick())
  }

  handleQueryChange(query, activeTab) {
    if (activeTab === 1) {
      this.setState({ query, departureQuery: query }, () => this.handleSearchClick())
    } else {
      this.setState({ query, arrivalQuery: query }, () => this.handleSearchClick())
    }
  }

  handleTabClick(tabNumb) {
    this.setState({ activeTab: tabNumb })
  }

  handleSearchClick(_e, _callBack) {
    clearTimeout(this.search)

    this.search = setTimeout(() => {
      const { query, activeTab, departureDate, arrivalDate, time } = this.state
      const { config, language } = this.props
      const contentLink = activeTab === 1 ? config.departureContentLink : config.arrivalContentLink
      let data = {
        contentLink: contentLink,
        date: activeTab === 1 ? departureDate : arrivalDate,
        query: query.trim(),
        sort: "",
        time: time,
        language: language,
      }
      endpoints
        .getFlights(data)
        .then((res) => res.data)
        .then((data) => {
          if (data.docs) {
            if (activeTab === 1) {
              this.setState(
                {
                  departingFlights: data.docs,
                },
                () => sessionStorage.setItem(keys.SESSION_STORAGE_DEPARTING_FLIGHTS, JSON.stringify(data.docs)),
              )
            } else {
              this.setState(
                {
                  arrivingFlights: data.docs,
                },
                () => sessionStorage.setItem(keys.SESSION_STORAGE_ARRIVING_FLIGHTS, JSON.stringify(data.docs)),
              )
            }
          }
        })
    }, 600)
  }

  handleFlightButtonClick(flightId) {
    const { activeTab, departingFlightId, arrivingFlightId } = this.state
    switch (activeTab) {
      case 1:
        if (departingFlightId === flightId) {
          this.setState({ departingFlightId: "", departingFlight: undefined })
        } else {
          const departingFlights =
            sessionStorage.getItem(keys.SESSION_STORAGE_DEPARTING_FLIGHTS) &&
            JSON.parse(sessionStorage.getItem(keys.SESSION_STORAGE_DEPARTING_FLIGHTS))
          const departingFlight = departingFlights?.find((x) => x.RecordId === flightId)
          this.setState({ departingFlightId: flightId, departingFlight })
        }
        break
      case 2:
        if (arrivingFlightId === flightId) {
          this.setState({ arrivingFlightId: "", arrivingFlight: undefined })
        } else {
          const arrivingFlights =
            sessionStorage.getItem(keys.SESSION_STORAGE_ARRIVING_FLIGHTS) && JSON.parse(sessionStorage.getItem(keys.SESSION_STORAGE_ARRIVING_FLIGHTS))
          const arrivingFlight = arrivingFlights?.find((x) => x.RecordId === flightId)
          this.setState({ arrivingFlightId: flightId, arrivingFlight })
        }
        break
    }
  }

  handleStateChange(state) {
    this.setState({ ...state })
  }

  handleProgressButtonClick(state) {
    this.setState({ ...state })
  }

  handleSubmit() {
    const { config, language } = this.props
    const data = {
      departingFlightId: this.state.departingFlightId,
      arrivingFlightId: this.state.arrivingFlightId,
      email: this.state.email,
      phone: this.state.mobile,
      language: language,
      hasCheckinLuggage: this.state.travelsWithLuggage || null,
      travelsWithChildren: this.state.travelsWithChildren || null,
      transportToAirport: this.state.travelForm === "null" ? null : this.state.travelForm || null,
    }

    this.setState({ ajaxSpinnerActive: true })
    endpoints
      .subscribeToTravelGuide(data)
      .then((res) => {
        if (res) {
          trackingHelper.trackProfileNewsletterSignup("newsletter", "cph profile signup - din rejseguide")
          this.setState({ activeStep: 4 })
        }
      })
      .catch((_error) => {
        Emitter.emit("*", {
          type: emits.REQUEST_CONTENT_MODAL_OPEN,
          modalJson: {
            usePortalStyling: true,
            h3: config.errorModalHeader || "Der er sket en fejl",
            richText: config.errorModalRichText || "Prøv igen senere",
          },
        })
      })
      .finally(() => {
        this.setState({ ajaxSpinnerActive: false })
      })
  }

  render() {
    const { config } = this.props
    const { travelsWithChildren, travelsWithLuggage, travelForm, activeStep } = this.state
    //if(true) return null //remove when text keys exists
    return (
      <React.Fragment>
        <Spinner isActive={this.state.ajaxSpinnerActive} isTransparent={this.state.ajaxSpinnerTransparent} />
        {this.state.heroOverlap && <HeroOverlap heroOverlap={this.state.heroOverlap} />}
        <div ref={this.containerRef}>
          {activeStep === 1 && (
            <TravelGuideStep1
              {...this.state}
              config={config}
              tabClickHandler={this.handleTabClick.bind(this)}
              dateChangeHandler={this.handleDateChange.bind(this)}
              timeChangeHandler={this.handleTimeChange.bind(this)}
              queryChangeHandler={this.handleQueryChange.bind(this)}
              searchClickHandler={this.handleSearchClick.bind(this)}
              buttonClickHandler={this.handleFlightButtonClick.bind(this)}
              stepButtonClickHandler={this.handleProgressButtonClick.bind(this)}
              writeToState={this.handleStateChange.bind(this)}
            />
          )}
          {activeStep === 2 && (
            <TravelGuideStep2
              config={config}
              activeStep={activeStep}
              travelsWithChildren={travelsWithChildren}
              travelsWithLuggage={travelsWithLuggage}
              travelForm={travelForm}
              stepButtonClickHandler={this.handleProgressButtonClick.bind(this)}
              writeToState={this.handleStateChange.bind(this)}
            />
          )}
          {activeStep === 3 && (
            <UserProfile>
              {(profile) => {
                return (
                  <TravelGuideStep3
                    {...this.state}
                    profile={profile}
                    config={config}
                    writeToState={this.handleStateChange.bind(this)}
                    stepButtonClickHandler={this.handleProgressButtonClick.bind(this)}
                    submitHandler={this.handleSubmit.bind(this)}
                  />
                )
              }}
            </UserProfile>
          )}
          {activeStep === 4 && (
            <TravelGuideStep4
              config={config}
              {...this.state}
              writeToState={this.handleStateChange.bind(this)}
              stepButtonClickHandler={this.handleProgressButtonClick.bind(this)}
              submitHandler={this.handleSubmit.bind(this)}
            />
          )}
        </div>
      </React.Fragment>
    )
  }
}
export default TravelGuide
